import { render, staticRenderFns } from "./taobaoTag.vue?vue&type=template&id=5ddaec56&scoped=true&"
import script from "./taobaoTag.vue?vue&type=script&lang=js&"
export * from "./taobaoTag.vue?vue&type=script&lang=js&"
import style0 from "./taobaoTag.vue?vue&type=style&index=0&id=5ddaec56&lang=scss&scoped=true&"
import style1 from "./taobaoTag.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddaec56",
  null
  
)

export default component.exports